import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getTeamContent = createAsyncThunk('/team/content', async (nopage) => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/approvalUserList/${userId}?page=${nopage}`, {})
    return response.data;
})

export const teamSlice = createSlice({
    name: 'teams',
    initialState: {
        isLoading: false,
        teams: []
    },
    reducers: {


        addNewTeam: (state, action) => {
            let { newTeamObj } = action.payload
            state.teams = [...state.teams, newteamsObj]
        },

        deleteTeams: (state, action) => {
            let { index } = action.payload
            state.teams.splice(index, 1)
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getTeamContent.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getTeamContent.fulfilled, (state, action) => {
                state.teams = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getTeamContent.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export const { addNewTeams, deleteTeams } = teamSlice.actions

export default teamSlice.reducer